export default __webpack_public_path__ + "static/media/hamburger_audio_off_button.9842538c.png";